import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { Buffer } from 'buffer';
import { State } from './state';
import { computed, ComputedRef } from 'vue';
import * as CryptoJS from 'crypto-js';

export type Getters = {
  getLoggedIn(state: State): ComputedRef<boolean | undefined>,
  getToken(state: State): Promise<string | undefined>,
  getUsinasAcesso(state: State): any[],
  getUsinaUserUsinaPadrao(state: State): any,
  getNomeUsuarioLogado(state: State): string | undefined,
  getDescricaoGrupoUsuarioLogado(state: State): string,
  getSegUsuarioId(state: State): number,
  getSegUsuarioGrupoId(state: State): number,
  getPermissoes(state: State): number[],
  getTokenLegacy(state: State): string | null,
  getTokenLegacy(state: State): any,
  getIsLegacy(state: State): boolean,
  getTokenLegacyDeserialized(state: State): any
}



export const getters: GetterTree<State, RootState> & Getters = {
  getLoggedIn: (state) => computed(() => state.oidc.value?.user?.expired),
  getNomeUsuarioLogado: (state) => state.oidc.value?.user?.profile.name,
  getDescricaoGrupoUsuarioLogado: (state) => "",
  getToken: async (state) => (await state.oidc.value.userManager!.getUser())?.access_token,
  getUsinasAcesso: (state) => [],
  getUsinaUserUsinaPadrao: (state) => [],
  getSegUsuarioId: (state) => state.integracao.usuarioIntegracaoId,
  getSegUsuarioGrupoId: (state) => state.integracao.grupoUsuario ? parseInt(CryptoJS.AES.decrypt(state.integracao.grupoUsuario, process.env.KEY as string).toString(CryptoJS.enc.Utf8)) : 0,
  getPermissoes: (state) => { return state.integracao.code ? JSON.parse(CryptoJS.AES.decrypt(state.integracao.code, process.env.KEY as string).toString(CryptoJS.enc.Utf8)) : []; },
  getTokenLegacy: (state) => { return sessionStorage.getItem("tokenLegacy") },
  getIsLegacy: (state) => { return sessionStorage.getItem("isLegacy") == '1' ? true : false },
  getTokenLegacyDeserialized: (state) => { return sessionStorage.getItem("tokenLegacy") ? parseJwt(sessionStorage.getItem("tokenLegacy")!): {}},
};
function parseJwt(token: string) {
  return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
}